import { initialState } from '../state';
import { BpmnXmlActions, BpmnXmlActionTypes } from '../actions';
import { BpmnDeploymentIdentifier } from '@ispm-shared/modules/bpmn';
export function bpmnDeploymentIdentifier(state = initialState.bpmnDeploymentIdentifier, action: BpmnXmlActions): BpmnDeploymentIdentifier {
  switch (action.type) {
    case BpmnXmlActionTypes.UPDATE_BPMM_DEPLOYMENT_IDENTIFIER:
      return action.payload.bpmnDeploymentIdentifier;
    default: {
      return state;
    }
  }
}
